import React, { useMemo } from 'react';
import { useMediaQuery } from '@material-ui/core';

type BreakType = 'before_hajimeru' | 'after_shinkansen';

interface Props {
  label: string;
  breakType: BreakType;
}

const DashboardButtonLabel: React.FC<Props> = ({ label, breakType }) => {
  const isStackedLayout = useMediaQuery('(max-width: 1030px)');
  const lines = useMemo(() => splitLabel(label, breakType, isStackedLayout), [label, breakType, isStackedLayout]);
  const styles = useMemo(() => getStyles(), []);

  if (lines.length === 1) {
    return <>{label}</>;
  }

  return (
    <div style={styles.container}>
      {lines.map(line => (
        <span key={`${breakType}-${line}`} style={styles.line}>
          {line}
        </span>
      ))}
    </div>
  );
};

function splitLabel(label: string, breakType: BreakType, isStackedLayout: boolean): string[] {
  if (!isStackedLayout) {
    return [label];
  }

  if (breakType === 'after_shinkansen') {
    const shinkansenIndex = label.indexOf('新幹線');
    if (shinkansenIndex === -1) {
      return [label];
    }

    const breakIndex = shinkansenIndex + '新幹線'.length;
    const firstLine = label.slice(0, breakIndex);
    const secondLine = label.slice(breakIndex);
    return firstLine && secondLine ? [firstLine, secondLine] : [label];
  }

  const hajimeruIndex = label.lastIndexOf('始める');
  if (hajimeruIndex === -1) {
    return [label];
  }

  const firstLine = label.slice(0, hajimeruIndex);
  const secondLine = label.slice(hajimeruIndex);
  return firstLine && secondLine ? [firstLine, secondLine] : [label];
}

function getStyles() {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    } as const,
    line: {
      textAlign: 'center'
    } as const
  };
}

export default DashboardButtonLabel;
